export const carousel = 'null';
